import React from 'react';
import { useSelector } from 'react-redux';
import { Button, Tooltip } from 'antd';
//
import { publish } from 'app/libs/core/PubSub';
import * as way from 'app/libs/core/PubSubWays';
//
import { placeAPI } from 'app/API/place.service.api';

import { history } from 'app/store';
import { removeSpecChars } from 'app/components/Utility/utility';
import withTranslations from 'app/components/HOGs/withTranslations';
import { useActions } from 'app/components/Utility/hooks/useAction.hooks';
import { ResetIcon, DeleteIcon } from '../../TourFullView/components/svg';
import { showDeleteConfirm } from '../../TourFullView/components/deleteConfirm';
import { cachHandler } from '../../../Utility/notificationMessage';
import { PlaceEmpty } from '../emptyDataPlace';

export const getPlaceLink = (title, id) =>
  `/place/${removeSpecChars(title)}_${id}`;

const SavePlace = (props) => {
  const { tr, router } = props;

  const { PlacesSetEmptyData, PlaceUserAmount, PlaceSetEditMode } =
    useActions();

  const data = useSelector((store) => store.placesData.data);
  const owner = useSelector((store) => store.placesData.data.user);
  const fetching = useSelector((store) => store.placesData.fetching);
  const edit = useSelector((store) => store.placesData.isEditMode);
  const user = useSelector((store) => store.authentication.user);
  const isLoggedIn = useSelector((store) => store.authentication.isLoggedIn);
  const isEmptyAddress = () => {
    const { address, lat, lng } = props.placesData.data;

    return address === '' && lat === '' && lng === '';
  };

  const save = () => {
    if (isEmptyAddress()) {
      cachHandler({
        message: tr['Place must have address'],
      });
      return;
    }
    const data = {
      ...props.placesData.data,
      options: {
        category: props.placesData.category,
        type: props.placesData.icon,
        color: props.placesData.color,
      },
    };

    placeAPI
      .savePlace(data)
      .then((res) => {
        const { code, response } = res;
        if (code === 200) {
          if (props.isCreatePlace(props.router)) {
            history.push(getPlaceLink(props.placesData.data.title, response));
          }
          props.PlaceSetEditMode(!props.edit);
        } else {
          console.log(res);
        }
      })
      .catch((err) => console.log(err));
  };

  const clearPlace = () => {
    publish(way.PLACE_MAP_CLEAN);
    PlacesSetEmptyData(PlaceEmpty(user));
    PlaceUserAmount();
  };

  const deletePlace = (url, data) => {
    console.log('Delete', url, data);
    placeAPI
      .removePlace(data.id)
      .then((res) => {
        const { code, response } = res;
        if (code === 200 && response === 'OK') {
          history.push(url);
        } else {
          cachHandler(res);
        }
      })
      .catch((err) => cachHandler(err));
  };

  const getCurrentUserId = () => {
    return isLoggedIn && user ? user.id : 0;
  };

  const hasUserPermition = () => {
    const id = getCurrentUserId();
    return id && id === +owner?.id;
  };

  const editChoose = (mode) => {
    if (hasUserPermition()) {
      const editMode = mode || !edit;
      PlaceSetEditMode(editMode);
    }
  };

  const getUrl = (router) => {
    const url = router ? router.location.pathname.split('/') : [];
    return url.splice(-1, 1);
  };

  const handleClick = (queryText, clear = false) => {
    const url = getUrl(router);
    const func = clear ? clearPlace : deletePlace;
    showDeleteConfirm(func, queryText, tr, url, data, data.id);
  };

  if (edit) {
    return (
      <div className="saveTour">
        <div className="placeDelete">
          <Tooltip title={tr.Reset}>
            <Button
              size="large"
              className="tour_history_reset"
              onClick={() => {
                handleClick(tr['Clear the Place'], true);
              }}
            >
              <ResetIcon />
            </Button>
          </Tooltip>
        </div>
        <Button
          type="primary"
          className="save-tour-button"
          size="large"
          onClick={() => save()}
        >
          {tr['Save and view place']}
        </Button>
      </div>
    );
  }

  if (!edit && hasUserPermition()) {
    return (
      <div className="saveTour">
        <div className="placeDelete">
          <Tooltip title={tr.Delete}>
            <Button
              size="large"
              className="tour_history_reset"
              onClick={() => {
                handleClick(tr['Delete the place?']);
              }}
            >
              <DeleteIcon />
            </Button>
          </Tooltip>
        </div>
        <Button
          type="primary"
          className="save-tour-button"
          size="large"
          onClick={fetching === true ? null : () => editChoose(!edit)}
        >
          {tr.Edit}
        </Button>
      </div>
    );
  }

  return null;
};

export default withTranslations(SavePlace);
